import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './MartialArtsComponent.metadata.json5';
import styles from '../../../SpaAndWellCommonStyles.module.scss';

function MartialArtsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('MartialArtsComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initializeMartialArtsFields = () => {
            const numofkidcamperyeaFieValue = _.get(modelVM, 'numofkidcamperyeaFie.value') !== undefined
                ? _.get(modelVM, 'numofkidcamperyeaFie.value') : 0;
            const numoftouattperyeaFieValue = _.get(modelVM, 'numoftouattperyeaFie.value') !== undefined
                ? _.get(modelVM, 'numoftouattperyeaFie.value') : 0;
    
            _.set(modelVM, 'numofkidcamperyeaFie.value', numofkidcamperyeaFieValue);
            _.set(modelVM, 'numoftouattperyeaFie.value', numoftouattperyeaFieValue);
        }
    
        useEffect(() => {
            initializeMartialArtsFields()
        }, [initializeMartialArtsFields])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthExpFie: {
            visible: !_.isUndefined(modelVM.value.othFie) && modelVM.value.othFie
        },
        ifsohowmansleperyeyeaFie: {
            visible: !_.isUndefined(modelVM.value.doyouhavsleFie) && modelVM.value.doyouhavsleFie
        },
        ifansyesabopleproddetFie: {
            visible: !_.isUndefined(modelVM.value.doyouhavaholharwaiaduFie) && modelVM.value.doyouhavaholharwaiaduFie
        },
        numofChithajoitheccamFie: {
            visible: !_.isUndefined(modelVM.value.numofkidcamperyeaFie) && modelVM.value.numofkidcamperyeaFie > 0
        },
        numofchiperweeFie: {
            visible: !_.isUndefined(modelVM.value.numofkidcamperyeaFie) && modelVM.value.numofkidcamperyeaFie > 0
        },
        howmanarefrestyFie: {
            visible: !_.isUndefined(modelVM.value.numoftouattperyeaFie) && modelVM.value.numoftouattperyeaFie > 0
        },
        howmanaretraFie: {
            visible: !_.isUndefined(modelVM.value.numoftouattperyeaFie) && modelVM.value.numoftouattperyeaFie > 0
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

MartialArtsComponent.propTypes = wizardProps;
export default withRouter(MartialArtsComponent);
